import expertLedImage from '../../../img/renaissance-new/learningImg/expert-led.webp';
import learnersTaughtImage from '../../../img/renaissance-new/learningImg/learners-taught.webp';
import handsOnProjectsImage from '../../../img/renaissance-new/learningImg/handson-projects.webp';
import codingProblemsImage from '../../../img/renaissance-new/learningImg/coding-problems.webp';
import practiceAssignmentImage from '../../../img/renaissance-new/learningImg/practice-assignment.webp';

// rectTop is the trapezoid's local top offset - verified against the Figma
// spec since rectTop + 136.5 (trapezoid height) equals each card's declared
// group height exactly (185.5 / 188.5 / 202.5 / 185.5 / 202.5).
// image is a single pre-composited fanned-card graphic (no per-badge
// positioning/rotation needed); imageWidth/imageHeight are its exact
// Figma-spec render size within the 336px-wide card (centered horizontally).
export const STATS = [
  {
    value: '300+',
    label: 'Expert-Led Lectures',
    rectTop: 49,
    image: expertLedImage,
    imageWidth: 286.61,
    imageHeight: 104.01,
  },
  {
    value: '20,000+',
    label: 'Learners Taught',
    rectTop: 52,
    image: learnersTaughtImage,
    imageWidth: 297,
    imageHeight: 104,
  },
  {
    value: '20+',
    label: 'Hands-On Projects',
    rectTop: 66,
    image: handsOnProjectsImage,
    imageWidth: 310.67,
    imageHeight: 117.66,
  },
  {
    value: '600+',
    label: 'Coding Problems',
    rectTop: 49,
    image: codingProblemsImage,
    imageWidth: 286.23,
    imageHeight: 103.69,
  },
  {
    value: '50+',
    label: 'Practice Assignments',
    rectTop: 66,
    image: practiceAssignmentImage,
    imageWidth: 311.9,
    imageHeight: 113.9,
  },
];
